import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white pt-16 pb-24 lg:pb-12" data-id="element-475">
      <div className="max-w-7xl mx-auto px-4" data-id="element-476">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-[1.45fr_0.8fr_1fr_1.15fr_1.35fr] lg:gap-6 xl:gap-8 mb-12" data-id="element-477">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-478">
            <img src="https://www.midatlanticmailboxes.com/uploaded/images/Redesign/Logo%201.png" alt="MidAtlantic Mailboxes Logo" className="h-12 bg-white p-2 rounded" data-id="element-479" />
            <p className="max-w-[320px] text-[#DAD7D2] text-sm leading-relaxed" data-id="element-480">
              Residential mailboxes, commercial delivery systems, address
              plaques, decorative signs, replacement parts, and exterior
              accents.
            </p>
          </div>

          {/* Company Links */}
          <div data-id="element-481">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-482">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-483">
              <li data-id="element-484">
                <a href="/AboutMidAtlanticMailboxInc.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-485">
                  About Us
                </a>
              </li>
              <li data-id="element-486">
                <a href="/3949.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-487">
                  Our Gallery
                </a>
              </li>
              <li data-id="element-488">
                <a href="/ContactUs.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-489">
                  Contact & FAQs
                </a>
              </li>
              <li data-id="element-490">
                <a href="/OurPolicies" className="hover:text-brand-gold hover:underline transition-all" data-id="element-491">
                  Our Policies
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div data-id="element-492">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-493">
              Resources
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-494">
              <li data-id="element-495">
                <a href="/Services.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-496">
                  Services
                </a>
              </li>
              <li data-id="element-497">
                <a href="/13.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-498">
                  Install Instructions
                </a>
              </li>
              <li data-id="element-499">
                <a href="/USPSResources.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-500">
                  USPS Resources
                </a>
              </li>
              <li data-id="element-501">
                <a href="/product-option-patterns.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-502">
                  Product Option Patterns
                </a>
              </li>
              <li data-id="element-503">
                <a href="/29.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-504">
                  Catalog
                </a>
              </li>
              <li data-id="element-505">
                <a href="/3948.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-506">
                  Dominion Valley Community
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div data-id="element-507">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-508">
              Shop Categories
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-509">
              <li data-id="element-510">
                <a href="/6m8/mailboxes.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-511">
                  Mailboxes
                </a>
              </li>
              <li data-id="element-512">
                <a href="/6m8/curbside-mailboxes.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-513">
                  Curbside Mailboxes
                </a>
              </li>
              <li data-id="element-514">
                <a href="/6m8/commercial-mailboxes-lockers.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-515">
                  Commercial Mailboxes
                </a>
              </li>
              <li data-id="element-516">
                <a href="/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-517">
                  Parts & Replacements
                </a>
              </li>
              <li data-id="element-518">
                <a href="/6m8/address-plaques-and-house-numbers.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-519">
                  Address Plaques
                </a>
              </li>
              <li data-id="element-520">
                <a href="/6m8/street-signs-traffic-signs.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-521">
                  Signs
                </a>
              </li>
              <li data-id="element-522">
                <a href="/6m8/message-boards.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-523">
                  Message Boards
                </a>
              </li>
              <li data-id="element-524">
                <a href="/6m8/lighting.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-525">
                  Lighting
                </a>
              </li>
              <li data-id="element-526">
                <a href="/6m8/home-garden-accents.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-527">
                  Home & Garden Accents
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-528">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-529">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-[#E2DFDD]" data-id="element-530">
              <li className="flex items-start gap-3" data-id="element-531">
                <Phone size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-532" />
                <a href="tel:301-620-7585" className="hover:text-brand-gold transition-colors" data-id="element-533">
                  301-620-7585
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-534">
                <MapPin size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-535" />
                <span className="text-[#DAD7D2]" data-id="element-536">
                  MidAtlantic Mailbox, Inc.
                  <br data-id="element-537" />
                  4507 Metropolitan Court Ste. D<br data-id="element-538" />
                  Frederick, MD 21704
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-539">
                <Clock size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-540" />
                <span className="text-[#DAD7D2]" data-id="element-541">
                  East Coast: Mon–Fri 10:30am–5:00pm EST
                  <br data-id="element-542" />
                  West Coast: Mon–Fri 9:00am–5:00pm MST
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#DAD7D2]" data-id="element-543">
          <p data-id="element-544">
            &copy; {new Date().getFullYear()} MidAtlantic Mailbox, Inc. All
            rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-545">
            <span data-id="element-546">Family-Owned</span>
            <span data-id="element-547">•</span>
            <span data-id="element-548">Woman-Owned</span>
          </div>
        </div>
      </div>
    </footer>;
}